import config from '../config';
import { notifyError, notifySuccess } from '../MyComponents/Toaster';
import axios from 'axios';

const armdv_backend_url = process.env.REACT_APP_ARMDV_BACKEND_API || 'https://staging-api.armdv.com';

const validateEntityId = async (
  entityId: string,
): Promise<{
  data: {
    entityId: string;
    accountType: string;
    displayName: string;
    isApproved: boolean;
  } | null;
  error: string | null;
}> => {

  try {
    const response = await axios.get(
      `${config.NODE_API_BASE_URL}/wso2/validate-entity/${entityId}`
    );
    return { data: response.data.data, error: null };
  } catch (error: any) {
    return {
      data: null,
      error:
        error?.response?.data?.message || "Invalid entity.",
    };
  }
};

export { validateEntityId };
